export default class Component {
    $target;
    $props;
    $state;
    isAppend;

    constructor($target, $props = {}, isAppend = false) {
        this.isAppend = isAppend;
        //jQuery 혼용
        if ($target instanceof jQuery) {
            this.$target = $target[0];
            if ($target.length > 1) console.warn('Multi Elements!');
        } else {
            this.$target = $target;
        }
        this.$props = $props; // $props 할당
        this.setup();

        if (!this.$target) return;

        this.render();
        this.setEvent();
        if ($(this.$target).find('input').length > 0) {
            $(this.$target).find('input:first').focus();
        }
    }

    setup() {
    };

    mounted() {
    };

    template() {
        return '';
    }

    render() {
        const _template = this.template();
        if (!_template) return;
        if (this.isAppend) {
            $(this.$target).append(_template);
        } else {
            this.$target.innerHTML = _template;
        }
        this.mounted();
    }

    setEvent() {
    }

    //일단 안 써보자
    setState(newState) {
        this.$state = {...this.$state, ...newState};
        this.render();
    }

    addEvent(eventType, selector, callback) {
        if (typeof selector === 'function') {
            callback = selector;
            selector = null;
        }

        const children = [...this.$target.querySelectorAll(selector)];
        const isTarget = (target) => children.includes(target) || target.closest(selector);

        let isPrevent = false;
        let isStop = false;
        if (eventType.includes(".prevent")) {
            eventType = eventType.replace(".prevent", "");
            isPrevent = true;
        }
        if (eventType.includes(".stop")) {
            eventType = eventType.replace(".stop", "");
            isStop = true;
        }

        const handler = (event) => {
            if (selector && !isTarget(event.target)) return;
            isPrevent && event.preventDefault();
            isStop && event.stopPropagation();
            callback(event);
        }

        $(this.$target).on(eventType, handler);
    }
}